var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStatuscomplete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.08317 2.91669C3.43975 2.91669 2.9165 3.43994 2.9165 4.08335V9.91669C2.9165 10.5601 3.43975 11.0834 4.08317 11.0834H9.9165C10.5599 11.0834 11.0832 10.5601 11.0832 9.91669V4.08335C11.0832 3.43994 10.5599 2.91669 9.9165 2.91669H4.08317ZM4.08317 9.91669V4.08335H9.9165L9.91767 9.91669H4.08317Z",
    fill: "#004921"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.41446 7.32433L5.65846 6.58291L4.8418 7.41708L6.41913 8.96116L9.16021 6.24808L8.34005 5.41858L6.41446 7.32433Z",
    fill: "#004921"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatuscomplete);
export default __webpack_public_path__ + "static/media/statuscomplete.77bb09079633ca44fe6e212e12d7b052.svg";
export { ForwardRef as ReactComponent };